import { Routes } from '@angular/router';
import { ProjectRoutes } from './project/project.routing';

export const CemRoutes: Routes = [
  {
    path: 'projects',
    children: [...ProjectRoutes],
    data: {
      title: 'Projects'
    }
  },
];